import { ColumnSettings, ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'

export interface ITemplateColumnSettings extends ColumnSettings {
  tmpl: string
  vars: string[]
  columns: string[]
}

export interface ITemplateColumn extends ITableColumn {
  Settings: ITemplateColumnSettings
}

export interface ITemplateCell extends ICell {
  settings: ITemplateColumnSettings
}

export class TemplateCell implements ITemplateCell {
  value: Cell
  settings: ITemplateColumnSettings

  constructor(value: Cell, settings: ITemplateColumnSettings) {
    this.value = value
    this.settings = settings
  }

  toString(): string {
    return this.value !== null && this.value !== undefined ? this.value.toString() : ''
  }

  toCell<T extends Cell>(newValue: T) {
    this.value = newValue
    return this
  }
}
